import { gql } from '@apollo/client'

export const BRAND_PACKAGING_FRAGMENT = gql`
  fragment BrandPackaging on PicOSBrandPackaging {
    brand {
      id
      name
    }
    packagingSize
    packagingUnit
    packagingQuantity
  }
`
